<template>
  <v-app>
    <section class="login-container">
      <form
        class="login-form"
        ref="register"
        @submit.prevent="login(user)"
      >
        <h2 class="primary-color">Connexion</h2>
        <v-text-field
          prepend-icon="mdi-account"
          :rules="rules"
          v-model="user.email"
          label="Username"
          required
        />
        <v-text-field
          prepend-icon="mdi-key"
          :rules="rules"
          v-model="user.password"
          type="password"
          label="Password"
          required
        />
        <v-btn
          :link="true"
          color="primary"
          routeName="Dashboard"
          type="submit"
          class="mt-4"
        >
          Login
          <v-icon dark right size="large">mdi-login</v-icon>
        </v-btn>
      </form>
    </section>
  </v-app>
</template>

<script>
  import authApi from '@/services/api/auth-api';

  export default {
    name: 'Login',
    data() {
      return {
        rules: [
          value => !!value || 'Required.'
        ],
        user: {
          email: '',
          password: ''
        }
      };
    },
    methods: {
      async login(user) {
        if (this.$refs.register.checkValidity()) {
          try {
            await authApi.login(user);
            this.$router.push({ name: 'Notifications' });
          } catch (error) {
            throw error;
          }
        } else {
          this.$refs.register.reportValidity();
        }
      }
    }
  };
</script>

<style lang="scss">
  @import "index";
</style>
